<div class="desktop-collect-email-container">
	<collect-email [title]="title" [buttonText]="buttonText" [initialEmail]="initialEmail" (submitted)="submitted()" (completed)="completed()">
	</collect-email>
</div>